import { Icon } from 'react-materialize'
import styled from 'styled-components'
import { TBButton } from '../../../Commons/Buttons/TBButton.react'

const Button = styled(TBButton)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  font-size: 2.5rem;
  background: transparent;
  i {
    font-size: 2.5rem;
  }
`

const ActionButton = ({ value, handleClick, children, ...props }) => {
  return (
    <Button variant="ghost" onClick={() => handleClick(value)} {...props}>
      {children}
      <Icon>arrow_forward_ios</Icon>
    </Button>
  )
}

export default ActionButton
